import React from 'react';

const EditableFieldCell = ({ value, displayValue, onClick }) => {
  return (
    <div
      className="mx-auto border border-solid border-border-tertiary rounded-lg w-16 h-8 flex items-center justify-center px-2 text-gray-600 text-xs cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={onClick}>
      <span>{displayValue}</span>
    </div>
  );
};

export default EditableFieldCell;
